// extracted by mini-css-extract-plugin
export default {"spinner":"loadingButton_spinner__wLLZJ","spin":"loadingButton_spin__F6NdN"};